/*
  bb-buyrow.js — la riga d'acquisto: quantita' e "Add to cart" affiancati,
  e il carrello che si apre a tendina invece di portare alla pagina /cart.

  PERCHE' UN BOTTONE NOSTRO E NON QUELLO DEL TEMA
  Sulla scheda prodotto convivono tre cose che vogliono comandare il bottone:
  il tema (Dawn), l'app dei campi personalizzati (Tepo) e noi. L'app, ogni volta
  che finisce di disegnarsi, prende il bottone del tema, gli cambia il type da
  "submit" a "button" e ci attacca il suo comportamento, che aggiunge al
  carrello e poi manda a /cart. Rimettergli il type a posto e' una rincorsa che
  non finisce: lei ridisegna, noi correggiamo, lei ridisegna.
  Quindi il bottone lo mettiamo noi. Gli altri due restano nascosti e fermi.

  COSA FA IL NOSTRO BOTTONE
  Esattamente quello che fa Dawn: raccoglie il modulo (che contiene id variante,
  quantita' e tutte le proprieta', comprese quelle dell'app), chiama
  /cart/add.js chiedendo le sezioni della tendina, e passa la risposta a
  cart-drawer.renderContents(), che disegna la tendina e la apre.
  Percio' in magazzino l'ordine arriva identico a prima.

  LA QUANTITA' SI PUO' SPOSTARE
  Il campo porta l'attributo form="...", cioe' dichiara lui a quale modulo
  appartiene: spostarlo nel DOM non cambia a chi viene inviato.
*/
(function () {
  'use strict';
  if (window.__bbBuyrow) return;
  window.__bbBuyrow = true;

  var riga = null;
  var mio = null;

  /*
    IL MODULO GIUSTO, NON IL PRIMO DELLA PAGINA (1 ott 2026).
    Prima era querySelector('form[action*="/cart/add"]'): il primo modulo
    /cart/add della pagina e' quello delle rate Shop Pay, che Dawn mette nel
    blocco prezzo. Da li' FormData non prendeva la quantita' (sempre 1).
    Il modulo vero e' quello a cui punta il campo quantita' (attributo form).
  */
  function form() {
    var q = document.querySelector('input[name="quantity"][form]');
    var f = q && document.getElementById(q.getAttribute('form'));
    return f ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment)');
  }
  function tendina() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  /*
    Nascondere gli altri bottoni con una classe non basta: il foglio di stile
    dell'app si carica dopo il nostro, quindi a parita' di !important vince lei
    e il suo bottone resta visibile. Due bottoni "Add to cart" uno sotto l'altro.
    Si spostano dentro un contenitore NOSTRO, tenuto nascosto: l'app puo'
    ristilizzare il suo bottone quanto vuole, il genitore resta invisibile.
    Restano nel DOM (non si cancellano) perche' l'app ci ragiona sopra.
  */
  var parcheggio = null;
  function spegniAltri() {
    if (!parcheggio || !parcheggio.isConnected) {
      parcheggio = document.querySelector('.bb-buyrow-park');
      if (!parcheggio) {
        parcheggio = document.createElement('div');
        parcheggio.className = 'bb-buyrow-park';
        parcheggio.setAttribute('aria-hidden', 'true');
        document.body.appendChild(parcheggio);
      }
    }
    var altri = document.querySelectorAll(
      '.product-form__submit, button[name="add"], [name="tcustomizer-add"], .tcustomizer-add-to-cart'
    );
    for (var i = 0; i < altri.length; i++) {
      var b = altri[i];
      if (b === mio || parcheggio.contains(b)) continue;
      b.classList.add('bb-buyrow-off');
      parcheggio.appendChild(b);
    }
  }

  function testoBottone() {
    var vecchio = document.querySelector('.product-form__submit span');
    var t = vecchio ? vecchio.textContent.trim() : '';
    return t || 'Add to cart';
  }

  function costruisci() {
    var f = form();
    var q = document.querySelector('.product-form__input--quantity, .product-form__quantity');
    var btns = document.querySelector('.product-form__buttons');
    if (!f || !q || !btns) return false;
    if (riga && riga.isConnected && mio && mio.isConnected) return true;

    var campo = q.querySelector('input[name="quantity"]');
    // senza form="..." spostarlo lo farebbe uscire dal modulo: si lascia stare
    if (!campo || !campo.getAttribute('form')) return false;

    mio = document.createElement('button');
    mio.type = 'button';
    mio.className = 'button button--full-width button--primary bb-buyrow-add';
    mio.innerHTML = '<span class="bb-buyrow-add__t">' + testoBottone() + '</span>' +
                    '<span class="bb-buyrow-add__spin" hidden aria-hidden="true"></span>';

    riga = document.createElement('div');
    riga.className = 'bb-buyrow-line';
    btns.parentNode.insertBefore(riga, btns);
    riga.appendChild(q);
    riga.appendChild(mio);
    q.classList.add('bb-buyrow-qty');

    mio.addEventListener('click', aggiungi);
    return true;
  }

  /* i campi obbligatori del blocco targhetta, se c'e' */
  function campiMancanti() {
    var f = window.__bbPlateValida;
    return typeof f === 'function' ? f() : null;
  }

  /*
    ERRORE VISIBILE (1 ott 2026): se Shopify rifiutava l'aggiunta (scorte
    finite, 422) o la rete cadeva, il bottone tornava "ADD TO CART" come se
    niente fosse e il messaggio finiva solo in console. Ora si usa il riquadro
    d'errore di Dawn, che sta gia' nella scheda.
  */
  function errore(testo) {
    var w = document.querySelector('product-form .product-form__error-message-wrapper');
    var m = w && w.querySelector('.product-form__error-message');
    if (!w || !m) return;
    if (testo) { m.textContent = testo; w.hidden = false; }
    else { m.textContent = ''; w.hidden = true; }
  }

  function aggiungi() {
    if (mio.getAttribute('aria-busy') === 'true') return;
    if (campiMancanti()) return;

    var f = form();
    var dr = tendina();
    if (!f) return;

    mio.setAttribute('aria-busy', 'true');
    var dati = new FormData(f);
    dati.delete('sections');
    dati.delete('sections_url');

    /*
      I due campi tecnici dell'app (_itemKey, _optionSetId) stanno nel suo
      widget, che vive FUORI dal modulo: FormData(modulo) non li prende.
      Vanno aggiunti a mano, se no l'ordine arriva senza il riferimento alla
      personalizzazione e l'app non la riconosce piu' nel suo pannello.
    */
    var tecnici = document.querySelectorAll('.tcustomizer-data input[name^="properties["]');
    for (var t = 0; t < tecnici.length; t++) {
      if (!dati.has(tecnici[t].name)) dati.append(tecnici[t].name, tecnici[t].value);
    }
    if (dr && dr.getSectionsToRender) {
      dati.append('sections', dr.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      dati.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: dati
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status) {                       // Shopify ha rifiutato (scorte, campi)
          if (window.console) console.warn('bb-buyrow', d.description || d.message);
          errore(d.description || d.message || 'This item could not be added to your cart.');
          return;
        }
        errore('');
        if (dr) {
          dr.classList.remove('is-empty');
          if (dr.renderContents) dr.renderContents(d);
          else if (dr.open) dr.open();
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('bb:added-to-cart'));
      })
      .catch(function (e) {
        if (window.console) console.error('bb-buyrow', e);
        errore('Something went wrong. Please try again.');
      })
      .then(function () { mio.removeAttribute('aria-busy'); });
  }

  /*
    L'app riprende il controllo per qualche secondo dopo il caricamento: si
    ricontrolla che la riga esista, che dentro ci siano solo quantita' e il
    nostro bottone, e che gli altri due bottoni restino spenti.
  */
  function tieni() {
    if (!costruisci()) return false;
    if (riga && riga.isConnected) {
      riga.classList.remove('tcustomizer-form-widget');
      var figli = Array.prototype.slice.call(riga.children);
      for (var i = 0; i < figli.length; i++) {
        var c = figli[i];
        if (c !== mio && !c.classList.contains('bb-buyrow-qty')) riga.parentNode.insertBefore(c, riga);
      }
    }
    spegniAltri();
    return true;
  }

  /*
    SI PARTE SOLO DOPO CHE <product-form> DI DAWN E' NATO (1 ott 2026).
    Questo file e' in <head> con defer, quindi girava PRIMA di product-form.js.
    Spostava il bottone submit fuori da <product-form> prima che Dawn lo
    cercasse: il costruttore di ProductForm trovava null e andava in errore, e
    con lui il cambio variante di product-info (prezzo, URL, id variante).
    Risultato: su bundle e felpa la scelta non cambiava niente e nel carrello
    finiva sempre la prima variante. Ora si aspetta che il custom element sia
    definito (define() costruisce subito gli elementi gia' nella pagina): Dawn
    si tiene il riferimento al suo bottone, che noi poi parcheggiamo nascosto.
    Sulle pagine senza scheda prodotto product-form.js non c'e' e non si parte,
    che e' giusto: qui non c'e' niente da costruire.
  */
  function avvia() {
    tieni();
    var mo = new MutationObserver(function () { tieni(); });
    mo.observe(document.body, { childList: true, subtree: true });
    var battito = setInterval(tieni, 400);
    setTimeout(function () { clearInterval(battito); mo.disconnect(); tieni(); }, 20000);
  }
  if (!window.customElements) avvia();
  else if (customElements.get('product-form')) avvia();
  else customElements.whenDefined('product-form').then(function () { setTimeout(avvia, 0); });
})();
